import { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import BaseLabel from "components/BaseLabel";
import { InputGeneral } from "components/Input";

interface Props {
  mConf?: string;
  textFieldValue?: string;
  setTextFieldValue?: (e: string) => void;
  errorSIAuthent: any;
  setErrorSIAuthent: (e: any) => void;
}

const MConfConfiguration: React.FC<Props> = ({
  mConf,
  setTextFieldValue,
  setErrorSIAuthent,
}) => {
  const { t } = useTranslation();
  let parsedObject: Record<string, string> = {};
  try {
    parsedObject = mConf ? JSON.parse(mConf) : {};
  } catch {
    parsedObject = {};
  }

  const defaultTemplate: Record<string, string> = {
    Server: "",
    PwdModerator: "",
    PwdAttendee: "",
    SharedSecret: "",
  };

  const [formValues, setFormValues] = useState<Record<string, string>>({
    ...defaultTemplate,
    ...parsedObject,
  });

  useEffect(() => {
    if (setTextFieldValue) {
      setTextFieldValue(JSON.stringify(formValues, null, 4));
    }
    setErrorSIAuthent(null);
  }, [formValues]);

  const handleChange = (key: string, value: string) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Grid container spacing={2} style={{ padding: "16px" }}>
      <Grid item xs={12}>
        <BaseLabel
          fontSize="18px"
          fontWeight="700"
          marginBottom="0px"
          marginTop="0px"
          marginLeft="0px"
          marginRight="0px"
        >
          {t("systemConfiguration.items.mConfAccessParams")}
        </BaseLabel>
      </Grid>

      {Object.keys(formValues).map((key) => (
        <Grid item xs={12} key={key}>
          <InputGeneral
            label={key}
            value={formValues[key]}
            onChange={(val) => handleChange(key, val)}
            required
            width={381}
            maxLength={500}
            error={false}
            type={key === "Server" ? "text" : "password"}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default MConfConfiguration;
